type TSimpleDiff<T = object> = (initial: T, current: T) => boolean;

/**
 * Compares two objects and determines if they are different.
 *
 * This function performs a deep comparison by converting both objects to JSON strings
 * and checking if the resulting strings are different.
 *
 * @param initial - The initial object to compare.
 * @param current - The current object to compare.
 * @returns `true` if the objects are different, `false` otherwise.
 *
 * @example
 * ```ts
 * const initial = { a: 1, b: 2 };
 * const current = { a: 1, b: 3 };
 *
 * const result = simpleDiff(initial, current);
 * console.log(result); // Output: true
 * ```
 */
export const simpleDiff: TSimpleDiff = (initial, current) => {
	return JSON.stringify(initial) !== JSON.stringify(current);
};
